import ArtistPillButton from "components/buttons/ArtistPillButton";
import { useFragment } from "react-relay";
import graphql from "babel-plugin-relay/macro";
import { ArtistPillButtonForUser_User$key } from "components/buttons/__generated__/ArtistPillButtonForUser_User.graphql";

const fragment = graphql`
  fragment ArtistPillButtonForUser_User on User {
    id
    username

    ProfilePhoto {
      id
      photoUrl
    }
  }
`;

type Props = {
  user: ArtistPillButtonForUser_User$key;
};

export default function ArtistPillButtonForUser({ user }: Props): JSX.Element {
  const userData = useFragment(fragment, user);

  return (
    <ArtistPillButton
      name={userData.username}
      src={userData.ProfilePhoto?.photoUrl}
    />
  );
}
